module.exports = __webpack_public_path__ + "static/media/www.finlandiatalo.fi.a1cc29a7.svg";